
export const EMAIL_INVALID='Email is Invalid'